<div class="CountryUpdate-desktop">
    <table>
        <thead>
            <th>
                <a [routerLink]="'../' + [tocCountryBased.uniqueNumber + getAllUuids() ]">
                    View full report
                </a>
            </th>
            <th *ngFor="let country of tocCountryBased.countryValues; let c = index;">
                <a [routerLink]="'../' + [tocCountryBased.uniqueNumber + getCountryUuids(tocCountryBased.countryValues.length, tocCountryBased.pillarValues.length, c) ]" matTooltip="View {{('uishared.CountryNames.' + country) | transloco}} report" matTooltipPosition="above">
                    {{('uishared.CountryNames.' + country) | transloco}}
                </a>
            </th>
        </thead>
        <tbody>
            <tr *ngFor="let pillar of tocCountryBased.pillarValues; let p = index;">
                <td>
                    <a [routerLink]="'../' + [tocCountryBased.uniqueNumber + getPillarUuids(tocCountryBased.countryValues.length, p) ]" matTooltip="View {{('uishared.pillars.' + pillar) | transloco}} report" matTooltipPosition="above">
                        {{('uishared.pillars.' + pillar) | transloco}}
                    </a>
                </td>
                <td *ngFor="let country of tocCountryBased.countryValues; let c = index;">
                    <!-- <a [routerLink]="'../' + [tocCountryBased.uniqueNumber + '_' + cellItem.key]" *ngFor="let cellItem of getCellContent(tocCountryBased.countryValues.length, p, c) | keyvalue">
                        {{cellItem.value}}
                    </a> -->
                    <div *ngFor="let cellItem of getCellContent(tocCountryBased.countryValues.length, p, c) | keyvalue">
                        <a *ngIf="cellItem.key.length != 14" [routerLink]="'../' + [tocCountryBased.uniqueNumber + '_' + cellItem.key]">
                            {{cellItem.value}}
                        </a>
                        <a *ngIf="cellItem.key.length === 14" [routerLink]="'../' + [cellItem.key]">
                            {{cellItem.value}}
                        </a>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>